import tableAppManualProviders from './tableAppManualProviders';

export default {
  title: 'Manual V.T. Tokens W',
  attributeName: 'manualVirtualTikets',
  getURL: 'appId/appManualProviderPlay',
  createURL: 'appId/appManualProviderPlay',
  updateURL: 'appId/appManualProviderPlay',
  removeURL: 'appId/appManualProviderPlay',
  idAttribute: 'providerId',
  sessionParams: ['appId'],
  noArea: true,
  loadFromFile: 'appId/appManualProviderFromFilePlay',
  loadFromFileHelp: 'To load tokens from file.',
  fileExtensionType: ['.csv', '.txt'],
  importMonitoringChanel: 'appManualProviderFromFile-appId',
  importMonitoringSessionParams: ['appId'],
  importMonitoringTitle: 'Import tokens process',
  exportAction: 'appId/appManualProfiederExportPlay',
  exportHelp: 'Export the token list',
  exportName: 'ManualProviderTokens.xlsx',
  tableConfig: tableAppManualProviders,
  autoUpdate: true,
  updateValuesAfterUpdate: ['used'],
};
